import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const cropDirectImageStoryMidTall = (data: PostData) => {
  const aspectRatio = data.media && data.media.height > data.media.width ? data.media.width / data.media.height : null;
  const maxAspectRatio = 9 / 16;
  const minAspectRatio = 4 / 5;
  return (
    data.publishingMethod === 'DIRECT' &&
    data.media &&
    data.profileType === 'business' &&
    data.media.type === MediaType.PHOTO &&
    aspectRatio &&
    aspectRatio < minAspectRatio &&
    aspectRatio > maxAspectRatio
  );
};
